import React, { useState } from "react";

import { Modal, Alert, DatePicker, Select, Col, Row } from "antd";
import api from "../../../../services/api";

export const RelatorioContratos = ({ history }) => {
  const { RangePicker } = DatePicker;
  const [dates, setDates] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState(null); // dt_remocao || dt_cadastro

  const handleOk = () => {
    if (!dates) {
      setError("Selecione as datas");
      return;
    }

    if (!filterBy) {
      setError("Selecione o filtro");
      return;
    }

    setError(null);
    setLoading(true);

    const paramsOptions = {
      dt_remocao: {
        dt_remocao_txt__gte: dates.initial.format("YYYY-MM-DD"),
        dt_remocao_txt__lte: dates.final.format("YYYY-MM-DD")
      },
      dt_cadastro: {
        dt_cadastro__gte: dates.initial.format("YYYY-MM-DD"),
        dt_cadastro__lte: dates.final.format("YYYY-MM-DD")
      }
    };

    api
      .get("/contratos/reports/operacao/", {
        params: paramsOptions[filterBy]
      })
      .then(({ data }) => {
        if (!data.report) {
          Modal.error({
            content: "Falha ao obter a url do relatório gerado."
          });
          return;
        }

        const url = data.report;

        Modal.success({
          content: "Relatório gerado com sucesso!"
        });

        window.open(url);
      })
      .catch(err => {
        console.error(err);

        Modal.error({
          content: "Ocorreu um erro ao gerar relatório."
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => history.goBack();

  const handleDateChange = value => {
    setError(null);

    if (!value || value.length !== 2) {
      setDates(null);
      return;
    }

    const initalDate = value[0];
    const finalDate = value[1];

    if (initalDate.isAfter(finalDate)) {
      return;
    }

    setDates({
      initial: initalDate,
      final: finalDate
    });
  };

  const handleFilterChange = value => {
    setError(null);
    setFilterBy(value);
  };

  return (
    <Modal
      title="Relatório de Contratos"
      visible
      onOk={handleOk}
      cancelText="Cancelar"
      onCancel={handleCancel}
      okText="Gerar"
      confirmLoading={isLoading}
    >
      <strong>Selecione as datas, filtro e clique em "Gerar"</strong>

      <div
        style={{
          marginTop: "15px"
        }}
      >
        {error && (
          <div
            style={{
              margin: "8px 0px 8px 0px"
            }}
          >
            <Alert message={error} type="error" />
          </div>
        )}
        <Row gutter={5}>
          <Col span={14}>
            <RangePicker
              onChange={handleDateChange}
              format={"DD/MM/YYYY"}
              placeholder={["Data inicial", "Data final"]}
              value={dates ? [dates.initial, dates.final] : null}
              style={{
                width: "100%"
              }}
            />
          </Col>
          <Col span={10}>
            <Select
              style={{ width: "100%" }}
              placeholder="Filtrar por..."
              onChange={handleFilterChange}
            >
              <Select.Option value="dt_remocao">Data remoção TXT</Select.Option>
              <Select.Option value="dt_cadastro">Data cadastro</Select.Option>
            </Select>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/Relatorios/Contratos/index.jsx